export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Changed our mornings completely! Before, getting the kids ready for school was a daily battle. Now they look at the visual routine, know what comes next, and get ready on their own. I finally have my mornings back.',
    name: 'Jennifer M.',
    location: 'Mother of two · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/0d0659fc-3c37-4454-b0b3-25c67901e93d.jpg',
  },
  {
    quote:
      'Goodbye to bedtime battles. The bedtime routine used to take hours. With this system, transitions are smooth and natural. My kids actually want to follow the routine now.',
    name: 'Marcus T.',
    location: 'Father of three · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ab93602a-48d3-4932-8604-3d6302a1ca1b.jpg',
  },
  {
    quote:
      'Works for ADHD kids. My son struggles with transitions and forgetfulness. This visual system gives him the structure he needs without the shame. He is more independent than ever.',
    name: 'Sarah K.',
    location: 'Mother of a neurodivergent child · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/264a71c0-0777-46e5-9a4c-1cd261648ec8.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Simple but powerful. I was skeptical, but this system is pure genius. It is not complicated, it is not overwhelming — it just works. Best parenting investment I have made.',
    name: 'David R.',
    location: 'Single parent · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/0820d469-f4e3-435d-83c9-110c617ff23d.jpg',
  },
  {
    quote:
      'Reduced my stress by 80%. I am a therapist and I recommend this to all my parent clients. The psychological foundation is solid and the execution is flawless.',
    name: 'Linda P.',
    location: 'Child psychologist & mom · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/2c2d3ce7-25da-4e0a-84ec-668e9f525874.jpg',
  },
  {
    quote:
      'My kids feel so proud. Now when my children complete their routine, they feel accomplished and proud. They are learning responsibility in the most positive way possible.',
    name: 'Amanda V.',
    location: 'Mother of two · New Zealand',
    flag: '🇳🇿',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/b3021c36-ad79-4549-8981-d3bb2e4ee220.jpg',
  },
];
